console.log('🔧 Variant description updater - Ritual theme version');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔧 Initializing for Ritual theme...');
  
  // Find all variant option inputs (radio buttons or select)
  const variantInputs = document.querySelectorAll('input[name="id"], fieldset.variant-picker input[type="radio"]');
  const descriptionTarget = document.querySelector('[data-variant-description-target]');
  
  console.log('Found variant inputs:', variantInputs.length);
  console.log('Found description target:', !!descriptionTarget);
  
  if (!descriptionTarget) {
    console.log('❌ No description target found');
    return;
  }
  
  // Listen to each variant input directly
  variantInputs.forEach(input => {
    input.addEventListener('click', function() {
      console.log('🔄 Variant clicked:', this.value);
      
      // Small delay to let the variant picker update
      setTimeout(() => {
        const selectedVariantId = this.value || this.dataset.variantId;
        console.log('📡 Updating for variant ID:', selectedVariantId);
        
        if (selectedVariantId) {
          updateDescription(selectedVariantId);
        }
      }, 100);
    });
  });
  
  async function updateDescription(variantId) {
    try {
      const url = `${window.location.pathname}?variant=${variantId}`;
      console.log('📡 Fetching:', url);
      
      const response = await fetch(url);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDescription = doc.querySelector('[data-variant-description-target]');
      
      if (newDescription) {
        console.log('✅ Got new description');
        console.log('Old:', descriptionTarget.textContent.substring(0, 50));
        console.log('New:', newDescription.textContent.substring(0, 50));
        
        // Smooth transition
        descriptionTarget.style.opacity = '0';
        
        setTimeout(() => {
          descriptionTarget.innerHTML = newDescription.innerHTML;
          descriptionTarget.style.opacity = '1';
          console.log('✅ Description updated!');
        }, 200);
      } else {
        console.log('⚠️ No new description found');
      }
    } catch (error) {
      console.error('❌ Error:', error);
    }
  }
  
  console.log('✅ Variant description updater ready');
});
